// Events allowed to reach Mixpanel. Everything else stays Google-Analytics-only.
export const MIXPANEL_EVENT_ALLOWLIST = new Set<string>([
  // Sale milestones (fired from segmentMiddleware via analytics.track)
  'saleGenerated',
  'salePaymentCompleted',
  // Product Adder V2 widget funnel
  'widget_viewed',
  'widget_step_opened',
  'widget_step_edited',
  'widget_step_filled',
  'widget_cta_clicked',
  // Upsell funnel (PR-4007 epic requirements, implemented in PR-4286)
  'upsell_modal_shown',
  'upsell_product_selected',
  'upsell_continued',
  'upsell_skipped',
  'upsell_booking_started',
  'upsell_booking_completed',
  'upsell_booking_abandoned',
  'upsell_completed',
  'checkout_started',
  'email_submitted',
  'account_found',
  'account_not_found',
  'login_password_selected',
  'login_code_selected',
  'code_sent',
  'code_validated',
  'login_completed',
  'account_created',
  'payment_method_selected',
  'pix_qr_shown',
  'three_ds_shown',
  'payment_failed',
  'checkout_completed',
]);

export const isMixpanelAllowedEvent = (event: string | undefined | null): boolean =>
  event != null && MIXPANEL_EVENT_ALLOWLIST.has(event);
